// Applies the theme lab's resolved tokens to <html> as an inline style, which
// is where tailwind.css reads a preset from: the --light-*/--dark-* pairs on
// the root feed every semantic token and every nested light/dark island.
//
// `data-style` is the current state. `data-compare-style`, when present, is a
// second preset the whole gallery flashes to while `c` is held, so two
// candidates can be compared on the same pixels without a side-by-side.
const isTyping = (event) =>
  ["INPUT", "SELECT", "TEXTAREA"].includes(event.target.tagName) || event.target.isContentEditable;

export const ThemeLab = {
  mounted() {
    // Broadcasts the lab's current state to any other open tab running
    // `theme_live.js`, so a preview elsewhere in the browser follows along
    // live. `hello` is what a page posts on load to ask for the state.
    this.channel = new BroadcastChannel("theme-lab");
    this.channel.onmessage = ({ data }) => {
      if (data?.type === "hello") this.broadcastState();
    };

    this.updated();

    this.onKeyDown = (event) => {
      if (event.key === "c" && !event.repeat && !isTyping(event) && this.el.dataset.compareStyle) {
        this.apply(this.el.dataset.compareStyle);
      }
    };
    this.onKeyUp = (event) => {
      if (event.key === "c") {
        this.updated();
      }
    };

    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
  },

  updated() {
    this.apply(this.el.dataset.style);
    this.broadcastState();
  },

  destroyed() {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    this.apply("");
    this.channel.close();
  },

  apply(style) {
    const root = document.documentElement;
    if ((root.getAttribute("style") || "") === (style || "")) return;
    root.style.cssText = style || "";
  },

  broadcastState() {
    this.channel.postMessage({
      type: "state",
      style: this.el.dataset.style,
      fontStylesheet: this.el.dataset.fontStylesheet || null,
    });
  },
};
